<template>
  <div class="text-sm text-gray-600 text-center mx-auto">
    <div v-if="plan === 'subscription'">
      {{ $t('products.mix_and_match_your_box', { size: selectedSize, price: formatCents(priceCents) }) }}
    </div>
    <div v-else>
      <p>
        Purchase
        {{ selectedSize }}
        meals once for
        {{ formatCents(priceCents) }}, or
        <b>
          <a
            class="text-blue-500 cursor-pointer"
            @click="plan = 'subscription'"
          >
            subscribe & save {{ formatCents(pricing.firstSavings) }}
          </a>
        </b>
        on your first order.
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useBundleStore } from '@/stores'
import { formatCents } from '@/utils'
const store = useBundleStore()
const { plan, pricing, priceCents, selectedSize } = storeToRefs(store)
</script>
